export default {
  snackbar: false,
  mainActiveService: 'hotel',
  usernameCache: '',
  currency: 'EUR',
  rates: [],
  ratesLastUpdated: null
}
